import React, { useEffect, useState } from 'react'
import { TextSM } from '../../../../Components/Text/NormalText';
import NuDate from '../../../../Components/Utils/NuDate';
import { Link, useLocation, useParams } from 'react-router-dom';
import { NewPill } from '../../../../Components/Utils/StatusPills';
import ViewMore from './ViewMore';
import ViewIcon from '../../../../Components/Icons/ViewIcon';
import DeleteIcon from '../../../../Components/Icons/Delete';
import axiosInstance from '../../../../Services/axiosCommon';
import NuAmount from '../../../../Components/Utils/NuAmount';

function PaymentmobCard({ item,getData,invoiceOutgoingViewId,index }) {

  const [isOpen, setIsOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  
           const location = useLocation();
  
  const Data = location?.state?.data
          const [data,setData] = useState(location.state?.data||[]);
  const confirmDelete = (id) => {
    setDeleteId(id);
    setIsOpen(true);
  };


  

           const getPayableView = () => {
            axiosInstance
              .get(`/invoices-outgoing/${invoiceOutgoingViewId}`)
              .then((res) => {
                setData(res?.data?.data);
              })
              .catch((error) => {
                console.log(error);
              });
          };

          useEffect(() => {
              if (!Data) {
              getPayableView();}
            }, []);

            const handleDelete = async () => {
                if (deleteId) {
                  try {
                    await axiosInstance.delete(`/invoices-outgoing/delete-payment/${deleteId}`);
                    getPayableView();
                  } catch (error) {
                    console.error("Error deleting:", error);
                  } finally {
                    setIsOpen(false);
                    setDeleteId(null);
                  }
                }
              };
   
    return (
        <div className="w-full border bg-white rounded-lg shadow-xl mt-4 mb-2">
   
        <div className="flex justify-between bg-[#ECEBF3]  rounded-t-lg items-center px-4 py-2">
          <p className=" w-auto h-auto   flex justify-center font-medium text-mainColor-500 items-center text-[12px] rounded-lg">
            {index + 1 || "#"}
          </p>
          <div className=" flex items-center gap-3">
            <div className="flex items-center gap-2 overflow-hidden">
              {item?.status &&
               
                  <NewPill text={item?.status} />
              
                }
            </div>
            <div className="px-4 py-2">
      <button onClick={() => confirmDelete(item?.id)} className="text-yellow-500 ml-2">
        <DeleteIcon />
      </button>
                  </div>
          </div>
        </div>
        <div className=" px-2 pb-2">
          <div className=" px-2 w-full h-8 mt-2 truncate  overflow-hidden">
            <Link
              className="hover:text-blue-600 text-mainColor-400 font-semibold text-[12px] lg:text-[12px] xl:text-[12px] w-full flex justify-between items-center"
              to={`/client-management/contracts/view/${item?.id}`}
              state={{ data: item }}
            >
              {item?.comments || "-"}
            </Link>
          </div>
          <div
            className="w-full flex justify-between items-center flex-wrap gap-2 mb-2 rounded-md p-2"
            style={{ border: "1px solid #C0C0C0" }}
          >
            {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Ref. : " || "-"} />
                <div className=" text-xs ">{item?.refNumber || "-"}</div>
              </div>
            </div> */}
            
           
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Received Amt. : " || "-"} />
                <div className=" text-xs text-right w-[68%] ">        <NuAmount  value={(item.receivedAmount)}/>
                </div>
              </div>
            </div>

            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Balance Amt. : " || "-"} />
                <div className=" text-xs text-right w-[68%] ">        <NuAmount  value={(item.balanceAmount)}/>
                </div>
              </div>
            </div>

            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Received On : " || "-"} />
                <div className=" text-xs ">
                                  {(item?.receivedOn != "None" && (
                                    <NuDate value={item?.receivedOn} format="DD-MMM-YY" />
                                  )) ||
                                    "-"}
                                </div>
              </div>
            </div>

            
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Paymt. Method : " || "-"} />
                <div className=" text-xs ">{item?.paymentMethod || "-"}</div>
              </div>
            </div>
  
            {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"InspectionDate : " || "-"} />
                <div className=" text-xs ">
                  {(item?.inspectionDate != "None" && (
                    <NuDate value={item?.inspectionDate} format="DD-MMM-YY" />
                  )) ||
                    "-"}
                </div>
              </div>
            </div> */}
  
           
          </div>
        </div>

        {isOpen && (
  <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">

        <div open={isOpen} onClose={() => setIsOpen(false)} >
        <div className="animate-scale-in w-72  max-h-[99vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
        <h2 className="text-sm font-semibold">Are you sure! You want to Delete?</h2>
            {/* <p className="text-gray-600 mt-2">Do you really want to delete this data? This action cannot be undone.</p> */}
            <div className="mt-4 flex justify-end space-x-2">
              <button onClick={() => setIsOpen(false)} className="px-3 py-[9px] cursor-pointer text-xs 2xl:text-sm  text-textColor-main bg-[#E6F2F2] hover:bg-gray-300
      rounded-md flex items-center">No</button>
              <button onClick={handleDelete} className="bg-textColor-main px-3 py-[9px] cursor-pointer  outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center mr-3">Yes</button>
            </div>
          </div>
        </div>
        </div>
        // </div>
      )}
      </div>
    );
  }

export default PaymentmobCard
